<template>
  <div>
    <b-modal
      id="modal-delete-tunjtdktetap"
      size="md"
      centered
      title="Perhatian"
      header-bg-variant="danger"
      header-text-variant="light"
    >
      <p>Apakah anda yakin akan menghapus data ini ?</p>

      <template #modal-footer>
        <b-button
          variant="primary"
          @click="hapus()"
        >
          {{ $store.state.form.ya }}
        </b-button>
        <b-button
          variant="secondary"
          @click="$bvModal.hide('modal-delete-tunjtdktetap')"
        >
          {{ $store.state.form.tidak }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "modalDelete",
  props: ["dataTunjanganTetap"],
  data() {
    return {
      busy:false,
      button:"Hapus"
    };
  },
  methods: {
    hapus() {
      let vm = this;
      vm.busy = true
      vm.button = "Mohon Tunggu"
      vm.$axios
        .post("poolTunjanganTidakTetap/delete", vm.dataTunjanganTetap)
        .then((res) => {
          if (res.data.message == "sukses") {
            vm.button = "Hapus";
            vm.busy = false;
            vm.$emit("alert", {
              variant: "success",
              msg: "BERHASIL MENGHAPUS INSENTIF",
              showing: true,
            });
            vm.$bvModal.hide("modal-delete-tunjtdktetap");
          } else {
            vm.button = "Hapus";
            vm.busy = false;
            vm.$emit("alert", {
              variant: "danger",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
          }
        })
        .catch((err) => {
          vm.button = "Hapus";
          vm.busy = false;
          vm.$emit("alert", {
            variant: "danger",
            msg: err.message.toUpperCase(),
            showing: true,
          });
        });
    },
  },
};
</script>
